"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _withdrawalManagement = require("@/api/financialManagement/withdrawalManagement");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'WithdrawalManagement',
  data: function data() {
    return {
      myMoney: 0,
      loading: false,
      loadingBox: false,
      queryData: {
        memberId: '',
        nickname: '',
        alipayAccountNo: '',
        withdrawNo: '',
        channelAppId: '',
        withdrawTypeList: null,
        // 账户类型
        giveModel: null,
        createTimeStart: '',
        createTimeEnd: '',
        page: 1,
        size: 10,
        status: ''
      },
      statusTypeDataIndex: 0,
      statusTypeData: [{
        name: '所有',
        id: ''
      }, {
        name: '待审核',
        id: 0
      },
      // { name: '待打款', id: 1 },
      {
        name: '审核拒绝',
        id: 2
      }, {
        name: '已打款',
        id: 3
      }
      // { name: '审核拒绝', id: 2 },
      // { name: '审核通过自动打款', id: 3 },
      // { name: '系统自动', id: 3 }
      ],
      checkList: ['用户ID', '用户昵称', '收款支付宝', '支付宝姓名', '自购订单数', '提现金额(元)', '扣税金额(元)', '审核打款状态', '账户类型', '提现流水号', '申请时间', '拒绝原因', '审核触发原因'],
      tableData: [],
      total: 0,
      // 条数
      processingPopup: false,
      // 审核处理
      multipleSelection: [],
      // 批量操作数组
      // 审核处理
      itemData: {},
      form: {
        memberId: '',
        withdrawNo: '',
        status: 2,
        remark: ''
      },
      rules: {
        remark: [{
          required: true,
          message: '请输入拒绝理由',
          trigger: 'blur'
        }]
      },
      isNext: false,
      auditing: false,
      // 审核中防重标志
      loadingList: false // 列表加载中防重标志
    };
  },
  created: function created() {
    var withdrawalManagement_data = localStorage.getItem('withdrawalManagement_data');
    if (withdrawalManagement_data) {
      this.checkList = JSON.parse(withdrawalManagement_data);
    }
    var withdrawalManagement_statusTypeDataIndex = sessionStorage.getItem('withdrawalManagement_statusTypeDataIndex');
    if (withdrawalManagement_statusTypeDataIndex) {
      this.statusTypeDataIndex = Number(withdrawalManagement_statusTypeDataIndex);
    }
    if (sessionStorage.getItem('withdrawalManagement_query')) {
      this.queryData = JSON.parse(sessionStorage.getItem('withdrawalManagement_query'));
    }
    this.onListWithdrawApplyPaged();
  },
  methods: {
    // 列表
    onListWithdrawApplyPaged: function () {
      var _onListWithdrawApplyPaged = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, req, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!this.loadingList) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this.loadingList = true;
              this.loading = true;
              _context.p = 2;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context.n = 3;
              return (0, _withdrawalManagement.listWithdrawApplyPaged)(params);
            case 3:
              res = _context.v;
              _context.n = 4;
              return (0, _withdrawalManagement.statisticWithdraw)(params);
            case 4:
              req = _context.v;
              this.myMoney = req.data.giveAmount;
              if (res.code === 0) {
                this.tableData = res.data.data;
                this.total = res.data.total;
              }
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              console.log(_t);
            case 6:
              _context.p = 6;
              this.loading = false;
              this.loadingList = false;
              return _context.f(6);
            case 7:
              return _context.a(2);
          }
        }, _callee, this, [[2, 5, 6, 7]]);
      }));
      function onListWithdrawApplyPaged() {
        return _onListWithdrawApplyPaged.apply(this, arguments);
      }
      return onListWithdrawApplyPaged;
    }(),
    // 查询
    onInquire: function onInquire() {
      sessionStorage.setItem('withdrawalManagement_query', JSON.stringify(this.queryData));
      sessionStorage.setItem('withdrawalManagement_statusTypeDataIndex', this.statusTypeDataIndex);
      this.queryData.page = 1;
      this.queryData.size = 10;
      this.onListWithdrawApplyPaged();
    },
    // 重置
    onInitialize: function onInitialize() {
      this.onInit();
      this.onListWithdrawApplyPaged();
      sessionStorage.setItem('withdrawalManagement_query', JSON.stringify(this.queryData));
      sessionStorage.setItem('withdrawalManagement_statusTypeDataIndex', this.statusTypeDataIndex);
    },
    // 初始化
    onInit: function onInit() {
      this.queryData = {
        memberId: '',
        nickname: '',
        alipayAccountNo: '',
        withdrawNo: '',
        channelAppId: '',
        withdrawTypeList: null,
        // 账户类型
        giveModel: null,
        createTimeStart: '',
        createTimeEnd: '',
        page: 1,
        size: 10
      };
    },
    onStatusList: function onStatusList(data, index) {
      this.multipleSelection = [];
      sessionStorage.setItem('withdrawalManagement_statusTypeDataIndex', this.statusTypeDataIndex);
      this.statusTypeDataIndex = index;
      this.queryData.status = data.id;
      this.onInquire();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.onListWithdrawApplyPaged();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.onListWithdrawApplyPaged();
    },
    // 功能操作------------------------------------------------------
    // 审核处理
    onPass: function onPass(data) {
      this.itemData = data;
      this.processingPopup = true;
    },
    // ----------------------------------------
    onSubmit: function onSubmit(formName) {
      var _this = this;
      this.form.memberId = this.itemData.memberId;
      this.form.withdrawNo = this.itemData.withdrawNo;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.$confirm('是否确认此操作?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this.auditWithdrawApply();
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.processingPopup = false;
      this.form = {
        memberId: '',
        withdrawNo: '',
        status: 2,
        remark: ''
      };
    },
    // 全选
    handleSelectionChange: function handleSelectionChange(val) {
      // this.multipleSelection = val.map(item => item.withdrawNo)
      this.multipleSelection = val;
    },
    // 存储列
    onCheckBox: function onCheckBox() {
      localStorage.setItem('withdrawalManagement_data', JSON.stringify(this.checkList));
    },
    onClose: function onClose() {
      this.processingPopup = false;
      this.resetForm('form');
    },
    auditWithdrawApply: function () {
      var _auditWithdrawApply2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!this.auditing) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              this.auditing = true;
              _context2.p = 2;
              params = (0, _objectSpread2.default)({}, this.form);
              _context2.n = 3;
              return (0, _withdrawalManagement.auditWithdrawApply)(params);
            case 3:
              res = _context2.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作已提交，请留意实际处理结果'
                });
                this.resetForm('form');
                this.onListWithdrawApplyPaged();
              }
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              console.log(_t2);
            case 5:
              _context2.p = 5;
              this.auditing = false;
              return _context2.f(5);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 4, 5, 6]]);
      }));
      function auditWithdrawApply() {
        return _auditWithdrawApply2.apply(this, arguments);
      }
      return auditWithdrawApply;
    }(),
    // 用户详情
    onUserDetails: function onUserDetails(value) {
      this.$router.push({
        path: '/member/userDetails',
        query: {
          memberId: value.memberId,
          nickname: value.nickname
        }
      });
    },
    onBatchProcessing: function onBatchProcessing() {
      var _this2 = this;
      if (this.multipleSelection.length === 0) {
        this.$notify.error({
          title: '温馨提示',
          message: '请选择需要操作的数据'
        });
        return;
      }
      this.$confirm('确认对当前选中用户执行批量打款的操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.batchAuditApplyManual();
      });
    },
    // 批量
    batchAuditApplyManual: function () {
      var _batchAuditApplyManual2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var _this3 = this;
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              this.loadingBox = true;
              params = {
                status: 2,
                paramList: []
              };
              this.multipleSelection.forEach(function (item, index) {
                params.paramList.push({
                  memberId: item.memberId,
                  withdrawNo: item.withdrawNo
                });
              });
              _context3.n = 1;
              return (0, _withdrawalManagement.batchAuditApplyManual)(params);
            case 1:
              res = _context3.v;
              // 关闭 loading
              this.loadingBox = false;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: "".concat(res.data.successCount, "\u6761\u64CD\u4F5C\u6210\u529F")
                });
                setTimeout(function () {
                  _this3.$notify.error({
                    title: '温馨提示',
                    message: "".concat(res.data.failureCount, "\u6761\u64CD\u4F5C\u5931\u8D25")
                  });
                }, 500);
                this.multipleSelection = [];
                this.onListWithdrawApplyPaged();
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              this.loadingBox = true;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function batchAuditApplyManual() {
        return _batchAuditApplyManual2.apply(this, arguments);
      }
      return batchAuditApplyManual;
    }()
  }
};